export const BUILD_MUSE = 'BUILD_MUSE'
export const SET_MUSE_FIELD = 'SET_MUSE_FIELD'
